<template>
  <div class="p-15">
    <div
      v-for="({ options, text, level, key }, langKey) in userLanguages"
      :key="`language-select-${langKey}`"
      class="row language-row"
    >
      <LanguageSelectionCheckbox
        :level="level.toString()"
        :language-key="key"
        :text="$t(text)"
        :radio-options="options"
        @selection-updated="handleSelectionChanged"
      />
    </div>
  </div>
</template>

<script>
import { UPDATE_USER_LANGUAGE } from '@/state/mutation-types'
import LanguageSelectionCheckbox from '@/components/LanguageSelectionCheckbox.vue'

export default {
  components: { LanguageSelectionCheckbox },
  computed: {
    userLanguages() {
      return this.$store.state.user.languages
    },
  },
  methods: {
    handleSelectionChanged(newLanguageState) {
      this.$store.commit(UPDATE_USER_LANGUAGE, {
        languageKey: newLanguageState.languageKey,
        level: newLanguageState.level,
        checked: newLanguageState.checked,
      })
    },
  },
}
</script>
